<template>
<div>
  <el-progress v-if="progress>0" :percentage="progress"></el-progress>
  <div v-if="progress>0">{{progress_msg}}</div>
  <div class="search-wrap">
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
    <el-button size="mini" @click="computeDosageNumber1()">生成</el-button>
    <el-button size="mini" @click="updateMeterOrder('is_lock',1)">锁定</el-button>
    <el-button size="mini" @click="updateMeterOrder('is_lock',0)">反锁定</el-button>
    <el-button size="mini" @click="getExcel()" v-if="user_type==2">导出分摊能耗</el-button>
    <el-button size="mini" @click="getExcel2()" v-if="user_type==2">导出计算结构式</el-button>
    <el-button size="mini" @click="getCostExcel()">{{user_type==1?'导出业主能耗':'导出物业能耗'}}</el-button>
<!--    <el-button size="mini" @click="ocr()">识别</el-button>-->
    <el-button size="mini" type="danger" @click="deleteMeterOrder()">删除计费</el-button>
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="抄表月份">
        <el-date-picker
          v-model="mainObj.read_month"
          size="mini"
          type="month"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="pageChange(1)"
          placeholder="选择月">
        </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="能耗类型">
        <el-checkbox-group v-model="where.apportion_meter_types" @change="pageChange(1)">
          <el-checkbox v-for="item in apportion_meter_type_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
      <el-descriptions-item label="收费项目">
        <el-select size="mini" style="width: 100%" v-model="where.chargeItem_name_id" filterable clearable placeholder="收费项目" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_item_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="收费标准">
        <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="分析类型">
        <el-select size="mini" style="width: 100%" v-model="where.amount_tag" clearable filterable multiple placeholder="分析类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="(item,index) in amount_tag_list" :key="index" :label="item.name" :value="item.val"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="锁定状态">
        <el-select size="mini" style="width: 100%" v-model="where.is_lock" clearable placeholder="锁定状态" class="kuan" @change="pageChange(1)">
          <el-option label="全部" value=""></el-option>
          <el-option label="未锁定" value="0"></el-option>
          <el-option label="已锁定" value="1"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <div class="header-tip">
      三级表 [成本]： {{formatMoney(order_count_obj.amount3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      分摊损耗 [成本]： {{formatMoney(order_count_obj.xs_accumulate_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      固定金额： {{formatMoney(order_count_obj.fixed_amount3,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      分摊能耗 [成本]： {{formatMoney(order_count_obj.allocated_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      <br>
      四级表 [成本]： {{formatMoney(order_count_obj.amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      {{user_type==1?'业主':'物业'}}损耗 [成本]： {{formatMoney(order_count_obj.xs_accumulate_amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      固定金额： {{formatMoney(order_count_obj.fixed_amount4,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      {{user_type==1?'业主':'物业'}}能耗 [销售]： {{formatMoney(order_count_obj.total_sales_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
      <br>
      总计收费 【分摊能耗 [成本] + {{user_type==1?'业主':'物业'}}能耗 [销售]】： {{formatMoney(order_count_obj.all_amount,4)}} 元&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
  </div>
  <div>
    <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed></el-table-column>
      <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
      <el-table-column prop="number" label="仪表编号 "  width="150" fixed>
        <template slot-scope="scope">
          <el-link type="primary">{{scope.row.number||'无仪表编号'}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="仪表名称 " width="200" fixed></el-table-column>
      <el-table-column prop="name" label="锁定状态" width="100">
        <template slot-scope="scope">
          <span style="color: #ff0f0f;font-weight: bold" v-if="scope.row.is_lock===1">锁定</span>
        </template>
      </el-table-column>
      <el-table-column prop="meter_level" label="仪表等级 " width="100"></el-table-column>
      <el-table-column prop="energy" label="能耗类型" width="100">
        <template slot-scope="scope">
          {{energy_obj[scope.row.energy]}}
        </template>
      </el-table-column>
      <el-table-column prop="apportion_tip_name" label="分摊类型" width="100">
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.apportion_meter_type===1?'纯用量分摊':'线损分摊'}}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop="charge_name" label="收费标准"  width="150"></el-table-column>
      <el-table-column prop="current_price" label="费用单价"  width="100"></el-table-column>
      <el-table-column prop="dosage_number" label="本表计量"  width="100"></el-table-column>

      <el-table-column prop="dosage_number" label="线损差值"  width="100">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="scope.row.dosage_fun_name" placement="bottom">
            <span>{{scope.row.x_dosage_number}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="xs_accumulate_dosage_number" label="线损累计量"  width="100"></el-table-column>
      <el-table-column prop="total_dosage_number" label="总计用量"  width="100">
        <template slot-scope="scope">
          <el-tooltip effect="dark" content="总计用量=本表计量+线损累计量" placement="bottom">
            <span style="color: #000000;font-weight: bold">{{scope.row.total_dosage_number}}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column prop="total_amount" label="总费用"  width="100">
        <template slot-scope="scope">
          <span style="color: #ff0f0f;font-weight: bold">{{scope.row.total_amount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="total_amount" label="分摊金额"  width="100">
        <template slot-scope="scope">
          <span style="color: #ff0f0f;font-weight: bold">{{scope.row.allocated_amount}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="sales_unit_price" label="销售价"  width="100"></el-table-column>
      <el-table-column prop="total_amount" label="销售金额"  width="100">
        <template slot-scope="scope">
          <span style="color: #ff0f0f;font-weight: bold">{{scope.row.sales_amount}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="step_one_amount" label="固定金额[扣减前叠加]"  width="150"></el-table-column>
      <el-table-column prop="step_two_amount" label="固定金额[扣减后叠加]"  width="150"></el-table-column>
      <el-table-column prop="other_amount" label="固定金额[额外叠加]"  width="130"></el-table-column>
      <el-table-column prop="last_read_number" label="上次读数" width="100"></el-table-column>
      <el-table-column prop="read_number" label="本次读数" width="100"></el-table-column>
      <el-table-column prop="magnification" label="倍率" width="100"></el-table-column>

      <el-table-column prop="magnification" label="程序核对计算用量" width="120">
        <template slot-scope="scope">
          {{reNumber((scope.row.read_number-scope.row.last_read_number)*scope.row.magnification)}}
        </template>
      </el-table-column>

      <el-table-column label="操作 " width="180" fixed="right">
        <template slot-scope="scope">
          <!--            <el-button type="primary" size="mini" icon="el-icon-edit" @click="update(scope.row)" v-if="ERP.isPermission(4007002006)||ERP.isPermission(21004001006)||ERP.isPermission(8006001006)||ERP.isPermission(30006001006)">能耗</el-button>-->
          <el-button type="primary" size="mini" @click="showItemData(scope.row)">计算详情</el-button>
          <el-button size="mini" @click="showDosageNumberMap(scope.row.meter_id)">能耗图</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
    <el-input v-model="pageData.pageSize" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>

  <el-dialog title="业主变更提示" :visible.sync="dialogVisible" width="70vw">
    <div class="dialog-content">
      <MeterHouseCustomer v-if="dialogVisible">
        <el-button type="primary" size="mini" @click="computeDosageNumber()">计算费用</el-button>
      </MeterHouseCustomer>
    </div>
  </el-dialog>

  <el-dialog title="数据详情" :visible.sync="itemDataDialogVisible" width="80vw">
    <div class="dialog-content" style="height: 70vh;overflow-y: auto;">
      <el-descriptions :column="3" border size="mini" :labelStyle="{width: '100px'}">
        <el-descriptions-item label="仪表编号">{{itemData.number}}</el-descriptions-item>
        <el-descriptions-item label="仪表名称">{{itemData.name}}</el-descriptions-item>
        <el-descriptions-item label="仪表等级">{{itemData.meter_level}}</el-descriptions-item>
        <el-descriptions-item label="能耗类型">{{energy_obj[itemData.energy]}}</el-descriptions-item>
        <el-descriptions-item label="分摊类型">{{itemData.apportion_tip_name}}</el-descriptions-item>
        <el-descriptions-item label="收费标准">{{itemData.charge_name}}</el-descriptions-item>
        <el-descriptions-item label="费用单价">{{itemData.current_price}}</el-descriptions-item>
        <el-descriptions-item label="本表计量">{{itemData.dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="线损差值">{{itemData.x_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="线损累计量">{{itemData.xs_accumulate_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="总计用量">{{itemData.total_dosage_number}}</el-descriptions-item>
        <el-descriptions-item label="总费用">{{itemData.total_amount}}</el-descriptions-item>
        <el-descriptions-item label="分摊金额">{{itemData.allocated_amount}}</el-descriptions-item>
        <el-descriptions-item label="销售价">{{itemData.sales_unit_price}}</el-descriptions-item>
        <el-descriptions-item label="销售金额">{{itemData.sales_amount}}</el-descriptions-item>
        <el-descriptions-item label="固定金额[扣减前叠加]">{{itemData.step_one_amount}}</el-descriptions-item>
        <el-descriptions-item label="固定金额[扣减后叠加]">{{itemData.step_two_amount}}</el-descriptions-item>
        <el-descriptions-item label="固定金额[额外叠加]">{{itemData.other_amount}}</el-descriptions-item>
        <el-descriptions-item label="上次读数">{{itemData.last_read_number}}</el-descriptions-item>
        <el-descriptions-item label="本次读数">{{itemData.read_number}}</el-descriptions-item>
        <el-descriptions-item label="倍率">{{itemData.magnification}}</el-descriptions-item>
        <el-descriptions-item label="程序核对计算用量">{{reNumber((itemData.read_number-itemData.last_read_number)*itemData.magnification)}}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1" border size="mini" :labelStyle="{width: '100px'}">
        <el-descriptions-item label="上下级计算">
          <el-descriptions :column="1" border size="mini" :labelStyle="{width: '100px'}">
            <el-descriptions-item label="编号计算公式">
              {{itemData.dosage_fun}}
            </el-descriptions-item>
            <el-descriptions-item label="名称计算公式">
              {{itemData.dosage_fun_name}}
            </el-descriptions-item>
            <el-descriptions-item label="用量计算公式">
              {{itemData.dosage_fun_dosage_number}}
            </el-descriptions-item>
            <el-descriptions-item label="金额计算公式">
              {{itemData.dosage_fun_amount}}
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1" border size="mini" :labelStyle="{width: '100px'}">
        <el-descriptions-item label="损耗累计">
          <el-descriptions :column="1" border size="mini" :labelStyle="{width: '100px'}">
            <el-descriptions-item label="编号计算公式">
              {{itemData.dosage_x_fun}}
            </el-descriptions-item>
            <el-descriptions-item label="名称计算公式">
              {{itemData.dosage_x_fun_name}}
            </el-descriptions-item>
            <el-descriptions-item label="用量计算公式">
              {{itemData.dosage_x_fun_dosage_number}}
            </el-descriptions-item>
            <el-descriptions-item label="金额计算公式">
              {{itemData.dosage_x_fun_amount}}
            </el-descriptions-item>
          </el-descriptions>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-dialog>

</div>
</template>

<script>
import {Loading} from "element-ui";
import MeterHttp from "../../common/MeterHttp";
import MeterHouseCustomer from "../meter/MeterHouseCustomer";

export default {
  name: "MeterOrderList",
  components: {MeterHouseCustomer},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:"",
        chargeItem_name_id:"",
        charging_standard:"",
        amount_tag:[],
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      amount_tag_list:[
        {name:"公共能耗(分摊制)-电梯电费分摊",val:1},
        {name:"公共能耗(分摊制)-二次加压水泵电费分摊",val:2},
        {name:"公共能耗(分摊制)-照明电费分摊",val:3},
        {name:"公共能耗(分摊制)-消控室电费分摊",val:4},
        {name:"公共能耗(分摊制)-园区公共水费",val:5},
        {name:"公共能耗(包干制)-电梯电费分摊",val:6},
        {name:"公共能耗(包干制)-二次加压水泵电费分摊",val:7},
        {name:"公共能耗(包干制)-照明电费分摊",val:8},
        {name:"公共能耗(包干制)-消控室电费分摊",val:9},
        {name:"公共能耗(包干制)-园区公共水费",val:10},
        {name:"物业能耗(办公能耗)-物业办公电费",val:11},
        {name:"物业能耗(办公能耗)-物业办公水费",val:12},
        {name:"物业能耗(外协能耗)-外协电费",val:13},
        {name:"物业能耗(外协能耗)-外协水费",val:14},
        {name:"物业能耗(业主能耗)-业主电费",val:15},
        {name:"物业能耗(业主能耗)-业主水费",val:16},
      ],
      meter_type_list: [],
      house_charge_list:[],
      house_charge_item_list:[],
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
      order_count_obj:{
        allocated_amount:0,
        amount3:0,
        amount4:0,
        total_dosage_number:0,
        total_sales_amount:0,
        allocated_amount4:0,
        xs_accumulate_amount:0,
        xs_accumulate_amount4:0,
        all_amount:0,
        fixed_amount3:0,
        fixed_amount4:0,
      },
      progress: 0,
      socket_key:null,
      progress_msg:"",
      dialogVisible:false,
      itemData:{},
      itemDataDialogVisible:false,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.mainObj.project_id&&this.getHouseChargeitemNameList();
    this.mainObj.project_id&&this.getHouseChargeList();
    this.pageChange(1)
  },
  methods:{
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      where.amount_tag=where.amount_tag.join(',');
      MeterHttp.post("MeterOrder/getList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
      MeterHttp.post("MeterOrder/getDataStatistics",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      },res=>{
        if (res.code) {
          that.order_count_obj=res.data;
        }
      })
    },
    computeDosageNumber1(){
      const that = this;
      that.dialogVisible=true;
    },
    computeDosageNumber(){
      const that = this;
      that.dialogVisible=false;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      where.read_month=that.mainObj.read_month;

      let loadingInstance = Loading.service({ fullscreen: true });
      MeterHttp.post("MeterOrder/computeDosageNumber",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        socket_id:that.$socket.socket.getSocketId(),
      }, res => {
        if (res.code) {
          loadingInstance.close()
          that.$socket.socket.on('MeterOrderCompute',(data)=>{
            let dataObj = JSON.parse(data.content);
            that.progress = dataObj.progress;
            that.progress_msg = dataObj.msg;
            if(that.progress==100){
              that.socket_key = null;
              that.$message.success('生成成功');
              that.pageChange(1)
              that.$socket.socket.off('MeterOrderCompute');
              that.progress = 0;
            }
          })
        }else {
          that.$message.error(res.msg || "数据异常");
          loadingInstance.close()
        }
      })
    },
    showDosageNumberMap(meterId){
      const that = this;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      window.open(`/#/show/MeterOrderMap?projectId=${that.mainObj.project_id}&readMonth=${where.read_month}&meterId=${meterId}`+"&type="+this.$route.query.type)
    },
    reNumber(x){
      return Math.floor(x*100)/100
    },
    getExcel() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrder/getExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          if (res.code) {
            that.initTaskClient(res.data,()=>{

            })
          }else {
           that.$message.error(res.msg || "数据异常");
          }
        }
      })
    },
    getExcel2() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrder/getExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize,
        url:"MeterOrder/getExcel2"
      }, res => {
        if (res.code) {
          if (res.code) {
            that.initTaskClient(res.data,()=>{

            })
          }else {
            that.$message.error(res.msg || "数据异常");
          }
        }
      })
    },
    getCostExcel() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrder/getCostExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.initTaskClient(res.data,()=>{

          })
        }else {
          that.$message.error(res.msg || "数据异常");
        }
      })
    },
    initEvent(socket_key,callback){
      const that = this;
      that.socket_key = socket_key;
      MeterHttp.post("MeterOrder/getSocketKey",{
        socket_key: socket_key
      }, res => {
        console.log(res)
        if (res.code==1) {
          that.progress = res.progress||0;
          setTimeout(() => {
            that.initEvent(socket_key,callback)
          }, 2000)
        }else {
          that.socket_key = null;
          that.$message.success('生成成功');
          that.pageChange(1)
        }
      }
      )
    },
    initTaskClient(socket_key,callback){
      const that = this;
      that.socket_key = socket_key;
      MeterHttp.post("TaskClient/getTask",{
        socket_key: socket_key
      }, res => {
        if (res.code==1) {
          that.progress = res.data.progress||0;
          if(res.data.progress==100){
            that.$message.success(res.msg || "数据异常");
            that.socket_key = null;
            console.log(res.data)
            window.open(res.data.filepath)
            callback && callback()
          }else{
            setTimeout(() => {
              that.initTaskClient(socket_key,callback)
            }, 2000);
          }

        }else {
          that.socket_key = null;
          that.$message.error(res.msg || "数据异常");
          callback && callback()
        }
      });
    },
    deleteMeterOrder(){
      const that = this;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      that.$confirm('确认删除所生成的当月计费记录吗？').then(() => {
        MeterHttp.post("MeterOrder/deleteMeterOrder",{
          project_id:that.mainObj.project_id,
          ...where,
          user_type:(that.$route.query.type||0),
        }, res => {
          if (res.code) {
            that.$message.success('删除成功');
            that.pageChange(1)
          }
        });
      }).catch(() => {
        that.$message.error('已取消删除');
      })
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      this.where.chargeItem_name_id&&(where.chargeItem_name_ids=(this.where.chargeItem_name_id+''));
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    getHouseChargeitemNameList(){
      const that = this;
      let where={};
      this.mainObj.project_id&&(where.pindex_id=this.mainObj.project_id);
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getHouseChargeitemNameList",
        data:{
          project_id:that.mainObj.project_id,
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data;
        }
      });
    },
    updateMeterOrder(field_name,field_value){
      const that = this;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(this.multipleSelection.length==0){
        that.$confirm('目未选择仪表，确认后系统将按当前条件进行修改，请确认！').then(() => {
          where.read_month=that.mainObj.read_month;
          where.apportion_meter_types=where.apportion_meter_types.join(',');
          MeterHttp.post("MeterOrder/updateMeterOrder",{
            project_id:that.mainObj.project_id,
            ...where,
            user_type:(that.$route.query.type||0),
            field_name:field_name,
            field_value:field_value,
          },res=>{
            if (res.code) {
              that.getList();
            }else {
              that.$message.error(res.msg || "数据异常");
            }
          })
        });
      }else {
        that.$confirm('所选仪表将被修改，请确认！').then(() => {
          let meter_order_ids = this.multipleSelection.map(item=>item.id).join(',');
          where.read_month=that.mainObj.read_month;
          where.apportion_meter_types=where.apportion_meter_types.join(',');
          MeterHttp.post("MeterOrder/updateMeterOrder",{
            project_id:that.mainObj.project_id,
            ...where,
            user_type:(that.$route.query.type||0),
            meter_order_ids:meter_order_ids,
            field_name:field_name,
            field_value:field_value,
          },res=>{
            if (res.code) {
              that.getList();
            }else {
              that.$message.error(res.msg || "数据异常");
            }
          })
        });
      }
    },
    showItemData(item){
      this.itemData=item;
      this.itemDataDialogVisible=true;
    },
    handleCloseItemData(){
      this.itemDataDialogVisible=false;
      this.itemData={}
    },
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    },
    "mainObj.project_id":function (n,o) {
      if(n){
        this.getHouseChargeitemNameList();
      }
    },
    'where2.chargeItem_name_id': {
      handler(val, oldVal) {
        this.where.charging_standard="";
        this.getHouseChargeList();
      },
      deep: true
    }
  },
  computed:{
    user_type(){
      return this.$route.query.type
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderList.vue